import { createContext } from 'react';
import { AnyAbility, createMongoAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';

import { Ability } from '@/types';

const anonymousAbility = createMongoAbility([]);

export const AbilityContext = createContext<AnyAbility>(anonymousAbility);

export const Can = createContextualCan(AbilityContext.Consumer);

export function createAbility(rules = []) {
    // !IMPORTANT: Not sure if this is the right approach
    return createMongoAbility(rules) as Ability;
}
